/**
 * Accessibility labels and ARIA strings
 * Single source of truth for screen reader text across the app
 * Helps with consistency, internationalization, and maintenance
 */

export const A11Y_LABELS = {
  // Chat
  sendMessage: 'Send message',
  dismiss: 'Dismiss',

  // News & Articles
  shareArticle: 'Share article',

  // Navigation
  toggleMenu: 'Toggle navigation menu',
  closeMenu: 'Close navigation menu',

  // Forms
  togglePasswordVisibility: 'Toggle password visibility',
} as const;

/**
 * Touch target sizing constant for WCAG AAA compliance
 * Minimum 44x44px for all interactive elements
 */
export const TOUCH_TARGET_SIZE = 'min-h-[44px] min-w-[44px]' as const;
